const Advices: String[] = [
  "Remember that everything is good in moderation, even life to the fullest.",

  "Use the bed more often to rest.",

  "The health bar will gradually decrease if left unchecked.",

  "Do not forget to periodically leave the room and meet with your family and friends.",

  "Every choice you make determines the type of finals ending.",

  "You will never be able to load any save and try to go through again.",

  "Do not forget to purchase new equipment from merchants marked with the SALE symbol.",

  "Remember that the level of difficulty will depend on the skills you choose at the beginning.",

  "Different characters around you will treat you differently depending on your equipment, appearance features and the chosen communication style.",

  "Government officials, ordinary citizens and even animals will initially treat you badly if your chosen class is a Rapper.",

  `The "Rapper" class has no talents.`,

  "Remember that the authorities will never ask for your password. They know it.",

  "By choosing a low level of difficulty, you will be born into a rich family.",

  "If you have died, you can never be resurrected again.",

  "Girls can be aggressive if you grab them.",

  "If you want to have a nice weekend - spend it without a girl. But if you want to stay alive - do not use this rule.",
];

export default Advices;
